<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span> {{ $t("Account") }}</span>
        <span v-if="isUpdated">{{ form.name }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Name')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Name')"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Limit per day')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Limit per day')"
                vid="limit_per_day"
                rules="required"
              >
                <b-form-input
                  id="limit_per_day"
                  v-model="form.limit_per_day"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Limit per day')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Webhook')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Webhook')"
                vid="webhook"
                rules="required"
              >
                <b-form-input
                  id="webhook"
                  v-model="form.webhook"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Webhook')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Status')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Status')"
                vid="status"
                rules="required"
              >
                <v-select
                  v-model="form.status"
                  :options="additionalData.statuses"
                  :clearable="false"
                  label="label"
                  :reduce="status => status.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Server')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Server')"
                vid="server_id"
                rules="required"
              >
                <v-select
                  v-model="form.server_id"
                  :options="additionalData.servers"
                  :clearable="false"
                  label="label"
                  :reduce="status => status.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Periodic restart')">
              <b-form-checkbox
                v-model="form.periodic_restart"
                value="1"
                unchecked-value="0"
                class="custom-control-success"
                name="check-button"
                switch
              />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Cpu Quota')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Cpu Quota')"
                vid="cpu_quota"
                rules="required"
              >
                <b-form-input
                  id="cpu_quota"
                  v-model="form.cpu_quota"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Cpu Quota')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group
              :label="$t('Cpu Period')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Cpu Period')"
                vid="cpu_period"
                rules="required"
              >
                <b-form-input
                  id="cpu_period"
                  v-model="form.cpu_period"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Cpu Period')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'

export default {
  name: 'AccountsEditModal',
  components: {

  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'accounts',
      modalName: 'modal-accounts-edit',
      createAbleFields: [
        'service_id',
        'name',
        'limit_per_day',
        'webhook',
        'status',
        'server_id',
        'periodic_restart',
        'cpu_quota',
        'cpu_period',
      ],
    }
  },
}
</script>

<style scoped>

</style>
